import useHttpProvider from "@/common/hooks/use-http";
import { Button } from "@/components/ui/button";
import { WinnersRoute } from "@/features/home/route";
import { Winner } from "@/features/winners/models/winner";
import * as WinnersService from "@/features/winners/services/winners";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PreviousWinner from "../components/previous-winner";

function PreviousWinners() {
	const { http } = useHttpProvider();
	const navigate = useNavigate();
	const [previousWinners, setPreviousWinners] = useState<Winner[]>([]);

	const getPreviousWinners = async () => {
		try {
			const winners = await WinnersService.getPreviousWinners(http);
			setPreviousWinners(winners);
		} catch {}
	};

	useEffect(() => {
		getPreviousWinners();
	}, []);

	const styles = {
		background:
			"radial-gradient(58.09% 54.69% at 29.83% 2.93%, rgba(46, 219, 202, 0.30) 0%, rgba(8, 50, 46, 0.00) 100%), radial-gradient(301.04% 189.4% at 89.12% -41.16%, #2EDBCA 4.81%, #004096 43.8%, #470096 100%)",
		backgroundBlendMode: "plus-lighter, normal",
	};

	return (
		<div
			style={styles}
			className="flex flex-col gap-12 px-4 py-16 pr-8 text-center md:flex-row md:px-37 md:py-50"
		>
			<div className="flex flex-col gap-12 text-left md:max-w-4/10">
				<div className="flex flex-col gap-8">
					<span className="web-heading-h2 text-white">
						Previous <span className="text-green-300">Winners</span>
					</span>
					<p className="web-body-b1 text-white-80">
						Our community members have already landed incredible rewards! From
						state-of-the-art fishing gear to unforgettable trips, these lucky
						anglers have turned their passion into real prizes.
					</p>
				</div>

				<Button
					className="w-60 max-sm:hidden"
					onClick={() => navigate(WinnersRoute)}
				>
					View All
				</Button>
			</div>

			<div className="flex flex-row gap-8 overflow-scroll">
				{previousWinners.slice(0, 4).map((previousWinner, index) => (
					<PreviousWinner key={index} winner={previousWinner} />
				))}
			</div>

			<Button className="md:hidden" onClick={() => navigate(WinnersRoute)}>
				View All
			</Button>
		</div>
	);
}

export default PreviousWinners;
